<template lang="pug">
  .panel-listing
    .card
      .card-header Myindex
      .card-body
        .ad-item.row
</template>
<script>
import $ from "jquery";
import util from "../../lib/util";
export default {
  name: 'PanelIndex',
  data() {
    return {
      LANG : window.LANG,
      pageData : window.pageData,
    }
  },
  beforeMount: function () {

  },
  methods : {

  }
}
</script>



// WEBPACK FOOTER //
// src/modules/panel/Index.vue